import WebUniversalNewEx, { WUExtendPropsType } from '../../system/WebUniversalNewEx';
import { columnsheadId } from '../../universal/columnshead';
import DeviceTypeEdit from './DeviceTypeEdit';

const WebComponent = (props: any) => {

    //表头
    const columnsHead = [
        {
            title: '设备类型',
            dataIndex: 'deviceTypeName',
        },
        {
            title: '排序',
            dataIndex: 'sortBy',
            sorter: true,
        },
    ];
    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '设备类型',
        apiId: 'deviceType',
        showStates: true,
        columns,
        pagination: true,
        EditComponent: DeviceTypeEdit,
    };

    return (
        <WebUniversalNewEx props={extendProps}></WebUniversalNewEx>
    )
}

export default WebComponent